export default "__VITE_ASSET__nDdEpcXm__"